import { Stack } from "@fluentui/react";
import { useEffect, useState } from "react";
import { IReport_Merchant, IReport_Receipt } from "../../../shared/interfaces/IReceipAnalyzerEntities";
import { useAppContext } from "./AppContext";
import { useNavigate } from 'react-router';
import SConsciousApiService from "../services/SConsciousApiService";
import ProgressBar from "./ProgressBar";
import SummaryTable, { Column } from "./SummaryTable";
import React from "react";
import HeathMap from "./HeathMap";

export default function Receipts({ filter }: { filter?: string }) {    

    let _sConsciousApiService = new SConsciousApiService();
    const {appData, setAppData} = useAppContext(); // <-- get context method
    const navigate = useNavigate();

    function getColumns(): Column<IReport_Receipt>[] {
        return [
            {
                key: "merchant_name",
                label: "Receipt",
                width: '50%',
                sortable: true,
                total: false,
                render: (_: any, item: IReport_Receipt) => (
                    <div className='table-cell-content' onClick={() => handleNavigateToReceipt(item.receipt_id)} style={{ cursor: 'pointer' }}>
                        {(item as any).source_receipt_id && (
                            <span style={{ fontSize: '0.7rem', marginRight: 4, verticalAlign: 'middle' }}>👥</span>
                        )}
                        {item.merchant_name}
                    </div>
                ),
            },
            {
                key: "transaction_date",
                label: "Date",
                width: '33%',
                sortable: true,
                total: false,
            },
            {
                key: "total_amount",
                label: "Total",
                width: '22%',
                sortable: true,
                total: true,
                render: (_: any, item: IReport_Receipt) => {
                    const hasHome = (item as any).home_total_amount != null &&
                        (item as any).home_currency_code &&
                        (item as any).home_currency_code !== item.currency_code;
                    return (
                        <div className='table-cell-content' style={{ color: item.total_checks_out ? 'inherit' : 'red' }}>
                            {hasHome
                                ? `${(item as any).home_total_amount.toFixed(2)}`
                                : item.total_amount.toFixed(2)
                            }
                        </div>
                    );
                },
            },
        ];
    }
    
    const handleNavigateToReceipt = (receipt_id: string): void => {
        const existingReceipt = appData?.data?.reportReceipts?.find((receipt) => receipt.receipt_id === receipt_id);
        if (existingReceipt) {      
            // If receipt already exists, set it in analysisResult
            const merchant = appData.data.reportMerchants?.find((m) => m.merchant_id === existingReceipt.merchant_id);
            const productItems = appData?.data?.reportProductItems?.filter((item) => item.receipt_id === existingReceipt.receipt_id);

            //console.log("Navigating to receipt:", existingReceipt);

            setAppData(
                { 
                    ...appData, 
                    analysisResult: {
                        receipt: existingReceipt,
                        merchant: merchant ?? {} as IReport_Merchant,
                        items: productItems ?? []
                    }
                });
        }
        else {
            setLoading(true);
        }
        // Navigate to the Receipt component
        navigate(`/receipt?receiptId=${receipt_id}`);
    }

        
    // State to track loading status
    const [loading, setLoading] = useState<boolean>(false);

    // Fetch data when component mounts
    // and whenever appContext changes
    /* useEffect(() => {
        setLoading(true);

        // Get app data
        _sConsciousApiService.getAppData(appData?.userId).then((result) => {

            console.log("App data fetched successfully:", result);

            setAppData({
                ...appData,
                data: {
                    ...appData.data,
                    reportMerchants: result.reportMerchants || [],
                    corporations: result.corporations || [],
                    brands: result.brands || [],
                    reportReceipts: result.reportReceipts || [],
                    reportProductItems: result.reportProductItems || [] 
                }
            });

        }).catch((error: any) => {
            console.error("Error fetching app data:", error);
        });

        setLoading(false);
    
        console.log("Receipts component mounted, receipts:", appData?.data);        
    }, []); */
    
    return ( 

        loading ?
        
            <ProgressBar label="Loading data" progress={20} />

        :
            <Stack horizontalAlign="center">
                <div className="custom-grid-table-container">
                    <SummaryTable
                        data={(appData?.data?.reportReceipts || []).map((item, idx) => ({ id: idx, ...item }))}
                        columns={getColumns()}
                        filterKeys={['merchant_name' as any]}
                        externalFilter={filter}
                        header={true}
                        total={true}    
                    />
                </div>
            </Stack>
    )
}